<template>
  <div :class="['definition-wrapper', 'chart', 'table-chart', {'error_validate': mandatoryValidation}]">
    <GChart v-if="componentMounted"
      type="Table"
      :data="chartData"
      :options="chartOptions"
      :settings="chartSettings"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../../language'

export default {
  name: 'definition-table-chart',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'callTask'
  ],
  components: {
    GChart
  },
  data () {
    return {
      componentMounted: false,
      chartData: [],
      chartOptions: {},
      chartSettings: {}
    }
  },
  methods: {
  },
  beforeMount () {
    this.object.chartValue = {
      region: null,
      header: [
        {
          type: 'string',
          label: ''
        },
        {
          type: 'number',
          label: 'Envíos'
        },
        {
          type: 'number',
          label: 'Alcance'
        },
        {
          type: 'number',
          label: 'Interacciones'
        },
        {
          type: 'number',
          label: 'Suscripciones'
        }
      ],
      data: [
        ['Email', 2300, 1900, 200, 56],
        ['Formularios', '24', '24', '16', '6'],
        ['RR.SS.', '580', '10500', '1200', '220'],
        ['SMS', '1500', '1400', '160', '54']
      ]
    }
    var dataChart = transport.methods.getDataChart(JSON.parse(JSON.stringify(this.object.chartValue)))
    this.chartData = dataChart.chartData

    this.chartOptions.width = '100%'
    this.chartOptions.height = 300
    this.chartOptions.fontSize = 16

    this.chartSettings.packages = ['table']
    this.chartSettings.language = language(this.language, 'chart')

    this.componentMounted = true
  }
}
</script>

<style>
  .table-chart {
    min-height: 300px;
  }
  .google-visualization-table-tr-head {
    background-color: #efefef !important;
  }
  .google-visualization-table-table {
    font-size: 16px !important;
  }
  .google-visualization-table-table td {
    text-align: center !important;
  }
  .google-visualization-table-table td:first-child {
    font-weight: 900 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/chart/tableChart.vue